import environment from "../../../../environments/environment";
import { notifyUser } from "../../Utils/notifyUser";
import { axiosInterceptor } from "../authInterceptor";

const SYSTEM_SETTINGS_URL = environment.getSystemSettingsURL;
const UPDATE_LOAN_GRACE_PERIOD_URL = environment.updateLoanGracePeriodURL;
const SAVE_SYSTEM_SETTINGS_URL = environment.saveSystemSettingsURL;

const UPDATE_TODAY_DATE_BY_CID_URL = environment.updateTodayDateByCIdURL;
const CLIENT_TEST_CONFIG_TODAY_DATE_URL = environment.getClientTestConfigTodayDate;

const SAVE_PARTICIPANT_APPROVER_URL = environment.saveParticipantApprover;
const PARTICIPANT_APPROVER_PARTID_CLIENTID_URL = environment.getPartiApprByPartIdAndClientId
const PARTICIPANT_APPROVER_ID_TYPE_CLIENTID_URL = environment.getPartApprByIdAndTypeAndClient;
const PARTICIPANT_APPROVERID_CLIENTID_URL = environment.getPartApprByApprIdAndClientId;

const SAVE_INVOICE_TASK_PROPETIES_URL = environment.saveInvoiceTaskProperties;
const ALL_INVOICE_TASK_RPOERTIES_URL = environment.getAllInvoiceTaskProperties;
const INVOICE_TASK_PROPERTIES_TYPE = environment.getInvoiceTaskPropertiesByType;
const UPDATE_CLIENT_CONFIGURATION_SETTINGS_URL = environment.updateClientConfigurationSettings;

interface SystemSettings {

    id: number;
    clientId: number;
    attributeName: string;
    value: string;
    version: number;

    /*created_by 		
    created_time 
    last_updated_by 		
    last_updated_time
    */
}
interface ParticipantApprovers {

    clientId: number;
    participantId: number;
    approverId: string;
    approverType: string;
    version: 1
}



export async function getSystemSettings(attributeName: string, clientId: number) {

    try {
        const systemSettings = await axiosInterceptor.get(`${SYSTEM_SETTINGS_URL}${attributeName}&clientId=${clientId}`);
        return systemSettings;
    } catch (error: any) {
        return error;
    }
}

export async function updateLoanGracePeriod(gracePeriod: number, clientId: number) {

    try {
        const response = await axiosInterceptor.put(`${UPDATE_LOAN_GRACE_PERIOD_URL}${gracePeriod}&clientId=${clientId}`);
        return response;
    } catch (error: any) {
        notifyUser(error.response.data.message, 'error', "Loan Grace Period Update Failed!");
    }
}


export async function upddateSystemSetting(systemSettings: any) {
    try {
        const response = await axiosInterceptor.post(`${SAVE_SYSTEM_SETTINGS_URL}`, systemSettings, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response;
    } catch (error) {
        console.error('There was an error updating the System settings!', error);
        throw error;
    }
}

export async function saveSystemSetting(sysSettings: any) {

    try {
        const response = await axiosInterceptor.put(`${SAVE_SYSTEM_SETTINGS_URL}${sysSettings.id}?gracePeriod=${sysSettings.value}&isAllLoanApplicable=${sysSettings.isAllowLoans}&clientId=${sysSettings.clientId}`);
        return response;
    } catch (error) {
        console.error('There was an error saving the System settings!', error);
        throw error;
    }
}

// Today date  -- client_test_configuration

export async function updateTodayDateById(clientId: number, dateValue: string, key: string) {

    try {
        const response = await axiosInterceptor.patch(`${UPDATE_TODAY_DATE_BY_CID_URL}${dateValue}&key=${key}&clientId=${clientId}`);
        notifyUser(response.data.message, 'success', "Today Date Updated Successfully!");
        return response;
    } catch (error: any) {
        notifyUser(error.response.data.message, 'error', "Today Date Update Failed!");
    }
}

//client-test-config/today-date?key=today-sysdate-test-env-only&clientId=1
export async function getTodayDate(key: string, clientId: number) {

    try {
        const response = await axiosInterceptor.get(`${CLIENT_TEST_CONFIG_TODAY_DATE_URL}${key}&clientId=${clientId}`);
        return response;
    } catch (error: any) {
        return error;
    }
}

//participant approver
export async function saveParticipantApprover(participantApprovers: any) {

    try {
        const response = await axiosInterceptor.post(`${SAVE_PARTICIPANT_APPROVER_URL}`, participantApprovers, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response;
    } catch (error) {
        console.error('There was an error saving the participant approver!', error);
        throw error;
    }
}

//PARTICIPANT_APPROVER_PARTID_CLIENTID_URL 
export async function getParticipantApproverByPIdAndCId(id: number, clientId: number) {

    try {
        const response = await axiosInterceptor.get(`${PARTICIPANT_APPROVER_PARTID_CLIENTID_URL}${id}?clientId=${clientId}`);
        return response;
    } catch (error: any) {
        return error;
    }
}
export async function getPartApprByPartIdAndType(id: number, type: string, clientId: number) {

    try {
        const response = await axiosInterceptor.get(`${PARTICIPANT_APPROVER_ID_TYPE_CLIENTID_URL}${id}/approvers?${type}&clientId=${clientId}`);
        return response;
    } catch (error: any) {
        return error;
    }
}

export async function getPartApprByApprIdAndClientId(approverId: string, clientId: number) {

    try {
        const response = await axiosInterceptor.get(`${PARTICIPANT_APPROVERID_CLIENTID_URL}?${approverId}&clientId=${clientId}`);
        return response;
    } catch (error: any) {
        return error;
    }
}

//WORK FLOW settings 

export async function saveInvoiceTaskProperties(invoiceTaskPropertiesVOS: any) {

    try {
        const response = await axiosInterceptor.post(`${SAVE_INVOICE_TASK_PROPETIES_URL}`, invoiceTaskPropertiesVOS, {

        });

        return response;
    } catch (error) {
        console.error('There was an error saving the invoice task propeties', error);
        throw error;
    }
}

export async function getAllInvoiceTaskProperties(clientId: number) {

    try {
        const response = await axiosInterceptor.get(`${ALL_INVOICE_TASK_RPOERTIES_URL}clientId=${clientId}`);
        return response;
    } catch (error: any) {
        return error;
    }
}

export async function getInvoiceTaskPropertiesByType(type: string, clientId: number) {

    try {
        const response = await axiosInterceptor.get(`${INVOICE_TASK_PROPERTIES_TYPE}?${type}&clientId=${clientId}`);
        return response;
    } catch (error: any) {
        return error;
    }
}

export async function updateClientConfigurationSettings(clientId: number, vivo: any) {
    try {
        const response = await axiosInterceptor.patch(`${UPDATE_CLIENT_CONFIGURATION_SETTINGS_URL}${clientId}`, vivo);
        return response;
    } catch (error) {
        return error;
    }
}


